export default __webpack_public_path__ + "static/media/avataar.9648ce48.svg";